import React from "react"

class OrderableList extends React.Component {
  
  constructor(props) {
    super(props)
    this.state = {
      selected:false
    }
  }
  
  render() {
    var self = this
    $(function() {
      $( "#sortable").sortable({
        handle: ".handle",
        axis: "y",
        stop: function(event,ui) {
          var idsInOrder = $( "#sortable" ).sortable("toArray")
          self.props.onChange(idsInOrder) 
        }
      });
    });
    
    if(this.props.bookingButton === true) {
      var allInputs = this.props.allInputs.sort((a,b) => a.position - b.position).map(input => {
        return (
            <div className="row form-inline" style={{paddingTop:'5px', margin:"2px", background: "#efefef", border: "1px solid #dddddd"}}>
              <div className='col-sm-3' style={{paddingTop:'10px'}}>
                <span className="handle">&#9776;</span>
              </div>
              <div className='col-sm-3' style={{paddingTop:'10px'}}>
                <strong>{I18n.t('field') + ' ' + ':'}</strong>
                <div>{input.field}</div>
              </div>
              <div className="col-sm-3" style={{paddingTop:'10px'}}>
                <strong >{I18n.t('type') + ' ' + ':'}</strong>
                <div>{input.field_type}</div>
              </div>
              <div className='col-sm-3' style={{paddingTop:"10px"}}>
                <strong>Status:</strong>
                <Switch />
              </div>
          </div>
        )
      })
    } else {
      var allInputs = this.props.allInputs.sort((a,b) => a.position - b.position).map(input => {
        return (
          <div id={input.id} key={input.id} style={{background: "#efefef", border: "1px solid #dddddd"}}>
            {
              input.field 
              ? 
              <div className='content-div'><span className="handle">&#9776;</span>{input.field}</div>
              : 
              <div className='content-div row' style={this.props.onRemove ? { height: '50px' } : null}><div className="col-sm-6">{this.props.read_only ? null : <span className="handle">&#9776;</span>}{input.status && input.status == "disabled" ? <span>{input.name}<em>{` (${I18n.t(input.status)})`}</em></span> : input.name}</div>{this.props.onRemove && !this.props.read_only ? <div className='ol-remove-btn col-sm-6'><button type="button" className="btn btn-secondary" onClick={()=>this.props.onRemove(input.id)}>{I18n.t('remove')}</button></div> : null}</div>
            }
          </div>
        )
      })
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="orderable-list" ref="root">
              <div className="card">
              {this.props.read_only ? null :<p>{I18n.t(this.props.helperText)}</p>}
              </div>           
              <div id='sortable'>
                {allInputs}
              </div>        
          </div>
        </div>
      </div>
    )
  }
}

export default OrderableList